export const DEBUG = import.meta.env.VITE_NODE_ENV === "development";

export const debugLog = (...args: any[]) => {
  if (DEBUG) console.log(...args);
};

export const debugWarn = (...args: any[]) => {
  if (DEBUG) console.warn(...args);
};

/**
 * Silences log/debug/info/warn outside development so internal ids, user names
 * and API shapes stay out of a customer's devtools. console.error stays live so
 * real failures remain visible in production.
 *
 * Runs on import rather than being called from index.tsx: ES imports are
 * hoisted, so a call statement in index.tsx would run only after every other
 * module (Network, Socket) had already evaluated and logged. Importing this
 * module first is what guarantees the gate is in place before them.
 */
if (!DEBUG) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}
